import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import {
  selectTask,
  selectTasksLoading,
} from "../../../../redux/educator/selector";
import {
  getTaskById,
  learnerSubmitTask,
} from "../../../../redux/educator/actions";

const mapStateToProps = (state: StateType) => ({
  task: selectTask(state),
  loading: selectTasksLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getTaskById,
      learnerSubmitTask,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
